module.exports = __webpack_public_path__ + "img/logo-dashboard-icon.c057d0b7.svg";